import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Search, Calendar, User, ArrowRight, Loader2 } from 'lucide-react';
import PageBanner from '../components/PageBanner';
import { fetchArticles } from '../api/services';
import { useSettings } from '../context/SettingsContext';
import SectionRenderer from '../components/page-builder/SectionRenderer';
import { getPage } from '../lib/pageDefaults';

export default function Articles() {
  const { settings } = useSettings();
  const page = getPage(settings?.page_builder, '/artikel') || {};
  const [query, setQuery] = useState('');
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    fetchArticles({ limit: 50 })
      .then((data) => { if (alive) setArticles(data); })
      .catch(() => { if (alive) setArticles([]); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);

  const filtered = articles.filter((a) => a.title.toLowerCase().includes(query.toLowerCase()));

  return (
    <>
      <PageBanner
        title={page.title || "Artikel & Blog"}
        subtitle={page.subtitle || "Tips bisnis minuman, resep signature, dan panduan produk BelBel untuk pertumbuhan usaha Anda."}
        breadcrumb={['Artikel']}
      />

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-md mx-auto mb-12 relative">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
            <input
              type="text"
              placeholder="Cari artikel..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              className="w-full pl-11 pr-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:border-japo-green focus:ring-2 focus:ring-japo-green/20 text-sm"
            />
          </div>

          {loading ? (
            <div className="flex items-center justify-center py-20 text-gray-500">
              <Loader2 className="w-6 h-6 animate-spin mr-2" /> Memuat artikel...
            </div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filtered.map((a) => (
                <Link key={a.id} to={`/artikel/${a.slug}`} className="group bg-white rounded-2xl overflow-hidden card-shadow border border-gray-100">
                  <div className="aspect-[16/10] overflow-hidden">
                    <img src={a.image} alt={a.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-3 text-xs mb-3">
                      <span className="bg-japo-green/10 text-japo-green font-bold px-2.5 py-1 rounded-full">{a.category}</span>
                      <span className="flex items-center gap-1 text-gray-500"><Calendar className="w-3 h-3" />{a.date}</span>
                    </div>
                    <h3 className="font-bold text-lg text-gray-900 mb-3 leading-snug group-hover:text-japo-green transition-colors line-clamp-2">{a.title}</h3>
                    <p className="text-sm text-gray-600 line-clamp-3 mb-4">{a.excerpt}</p>
                    <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                      <span className="text-xs text-gray-500 flex items-center gap-1.5"><User className="w-3 h-3" />{a.author}</span>
                      <span className="text-japo-green font-bold text-sm inline-flex items-center gap-1 group-hover:gap-2 transition-all">
                        Baca <ArrowRight className="w-3.5 h-3.5" />
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
          {!loading && filtered.length === 0 && (
            <div className="text-center py-20 text-gray-500">Tidak ada artikel ditemukan.</div>
          )}
        </div>
      </section>

      <SectionRenderer sections={page.sections || []} />
    </>
  );
}
